import type { BreadcrumbItem } from '@bv/components/breadcrumb/BvBreadcrumbs.vue';

export const generateBreadcrumbs =
  (...MainItems: BreadcrumbItem[]): ((...items: BreadcrumbItem[]) => BreadcrumbItem[]) =>
  (...items: BreadcrumbItem[]): BreadcrumbItem[] => [...MainItems, ...items];
